// src/mocks/browser.ts

import { setupWorker } from 'msw';
import { handlers } from './handlers';

export const worker = setupWorker(...handlers);

// Dev env only, we make it available in `window`
if (process.env.NODE_ENV === 'development') {
  // @ts-expect-error — add to the global for use in the browser console
  window.worker = worker;
}
